import React from 'react';
import {Link} from "react-router-dom";

import AdminLayout from 'Pages/Admin/AdminLayout';

import {PrimaryButton, SecondaryButton} from 'Components/Button';
import {FormHandler, Input, Checkbox, Toggle, Select} from 'Components/Form';
import {Alert, Loading} from 'Components/Partials';
// import CashierSubscriptionSelector from 'Components/Cashier/SubscriptionSelector';

import AdminUsersApi from 'Services/Api/Admin/Users';
import AdminGroupsApi from 'Services/Api/Admin/Groups';

class UsersStore extends React.Component {
    /**
     * @var event_dates
     * @type {array}
     */
    event_dates = [
        {
            label: '5th',
            value: '5th'
        },
        {
            label: '6th',
            value: '6th'
        }
    ];

    /**
     * @var success
     * @type {string}
     */
    success = 'User ' + (this.props.match?.params?.user ? 'updated' : 'created') + ' successfully';

    /**
     * @var state
     * @type {{user_id: string}}
     */
    state = {
        user_id: this.props.match?.params?.user ?? '',
    };

    /**
     * @method componentDidMount
     */
    componentDidMount() {
        if (this.state.user_id) {
            this.loadUser();
        } else {
            this.props.setInitialValues({
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                password_confirmation: '',
                is_admin: false,
                enabled: true,
                automatically_verify_email: false,
                group_ids: null,
                send_user_invite: false,
                send_password_reset_link: false,
                store_number: '',
                employee_number: '',
                //accomodation_eligibility: false,
            });
        }
    }

    /**
     * @method loadUser
     */
    loadUser = async () => {
        const {user_id} = this.state;

        const response = await AdminUsersApi.get(user_id);

        let group_ids = response.data.data.groups.map(g => g.id);

        if (!window.base.features.allow_multiple_groups_per_user) {
            group_ids = group_ids[0];
        }

        this.props.setForm({
            ...response.data.data,
            group_ids
        });
    }

    /**
     * @method handleSubmit
     * @param {object} form
     * @return {Promise<*>}
     */
    handleSubmit = (form) => {
        const {user_id} = this.state;

        if (user_id) {
            return AdminUsersApi.patch(user_id, form);
        } else {
            return AdminUsersApi.post(null, form);
        }
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        let {user_id} = this.state;
        const {form, working, alert, setForm, handleInput, getFieldError, handleSubmit} = this.props;

        return (
            <AdminLayout title={'Users - ' + (user_id ? 'Update' : 'Create') + ' User'}>
                <form
                    className="divide-y divide-gray-200"
                    onSubmit={(e) => handleSubmit(e, this.handleSubmit, this.success, (user_id ? false : true))}
                >
                    <div className="mx-6">
                        {alert !== null && (<Alert {...alert} />)}

                        <div className="grid grid-cols-2 gap-4 mb-4">
                            <div>
                                <Input
                                    label="First Name"
                                    value={form.first_name}
                                    id="first_name"
                                    error={getFieldError('first_name')}
                                    onChange={(v) => handleInput('first_name', v)}
                                />
                            </div>

                            <div>
                                <Input
                                    label="Last Name"
                                    value={form.last_name}
                                    id="last_name"
                                    error={getFieldError('last_name')}
                                    onChange={(v) => handleInput('last_name', v)}
                                />
                            </div>

                            <div>
                                <Input
                                    label="Email"
                                    value={form.email}
                                    id="email"
                                    error={getFieldError('email')}
                                    onChange={(v) => handleInput('email', v)}
                                />
                            </div>

                            <div>
                                <Input
                                    label="Store Number"
                                    value={form.store_number}
                                    id="store_number"
                                    error={getFieldError('store_number')}
                                    onChange={(v) => handleInput('store_number', v)}
                                />
                            </div>

                            <div>
                                <Input
                                    label="Employee Number"
                                    value={form.employee_number}
                                    id="employee_number"
                                    error={getFieldError('employee_number')}
                                    onChange={(v) => handleInput('employee_number', v)}
                                />
                            </div>

                            <div>
                                <Select
                                    label="Event Date"
                                    value={form.event_date}
                                    id="event_date"
                                    onChange={(v) => handleInput('event_date', v)}
                                    options={this.event_dates}
                                />
                            </div>

                            {/*<div>
                                <Toggle
                                    label="Accomodation Eligibility"
                                    labelPlacement="top"
                                    value={form.accomodation_eligibility}
                                    id="accomodation_eligibility"
                                    error={getFieldError('accomodation_eligibility')}
                                    onChange={(v) => handleInput('accomodation_eligibility', v)}
                                />
                            </div>*/}

                            {!user_id &&
                                <>
                                    <div>
                                        <Toggle
                                            label="Send User Invite Email"
                                            labelPlacement="top"
                                            id="send_user_invite"
                                            value={form.send_user_invite}
                                            error={getFieldError('send_user_invite')}
                                            onChange={(v) => {
                                                if (v === false) {
                                                    setForm({
                                                        ...form,
                                                        send_user_invite: false,
                                                        send_password_reset_link: false
                                                    });
                                                } else {
                                                    handleInput('send_user_invite', v);
                                                }
                                            }}
                                        />
                                    </div>

                                    {(form.is_admin || !window.base.using_hard_password) &&
                                        <>
                                            {form.send_user_invite &&
                                                <div>
                                                    <Toggle
                                                        label="Send User Invite Email With Secure Link To Set Password"
                                                        labelPlacement="top"
                                                        id="send_password_reset_link"
                                                        value={form.send_password_reset_link}
                                                        error={getFieldError('send_password_reset_link')}
                                                        onChange={(v) => handleInput('send_password_reset_link', v)}
                                                    />
                                                </div>
                                            }

                                            {!form.send_password_reset_link &&
                                                <>
                                                    <div>
                                                        <Input
                                                            label="Password"
                                                            type="password"
                                                            value={form.password}
                                                            id="password"
                                                            error={getFieldError('password')}
                                                            onChange={v => handleInput('password', v)}
                                                        />
                                                    </div>

                                                    <div>
                                                        <Input
                                                            label="Password Confirmation"
                                                            type="password"
                                                            value={form.password_confirmation}
                                                            id="password_confirmation"
                                                            error={getFieldError('password_confirmation')}
                                                            onChange={v => handleInput('password_confirmation', v)}
                                                        />
                                                    </div>
                                                </>
                                            }
                                        </>
                                    }

                                    {window.base.features.verify_registrations &&
                                        <div className="my-auto">
                                            <Checkbox
                                                label="Automatically Verify Email"
                                                value={form.automatically_verify_email}
                                                id="automatically_verify_email"
                                                error={getFieldError('automatically_verify_email')}
                                                onChange={(v) => handleInput('automatically_verify_email', v)}
                                            />
                                        </div>
                                    }
                                </>
                            }

                            <div>
                                <Toggle
                                    label="Admin"
                                    labelPlacement="top"
                                    id="is_admin"
                                    value={form.is_admin}
                                    error={getFieldError('is_admin')}
                                    onChange={(v) => handleInput('is_admin', v)}
                                />
                            </div>

                            {window.base.features.groups &&
                                <div>
                                    <Select
                                        label="Group"
                                        id="group"
                                        value={form.group_ids}
                                        error={getFieldError('group_ids')}
                                        onChange={(v) => handleInput('group_ids', v)}
                                        isAsync
                                        searchCallback={(data) => AdminGroupsApi.get(null, {
                                            ...data,
                                            hasNoTeam: true,
                                        })}
                                        searchLabelKey="name"
                                        allowNull={!window.base.features.user_must_belong_to_a_group || form.is_admin}
                                        isMulti={window.base.features.allow_multiple_groups_per_user}
                                        key={form.is_admin}
                                    />
                                </div>
                            }

                            {window.base.features.user_can_invite &&
                                <>
                                    <Input
                                        label="Number of Invites"
                                        value={form.number_of_invites}
                                        id="number_of_invites"
                                        error={getFieldError('number_of_invites')}
                                        onChange={(v) => handleInput('number_of_invites', v)}
                                        type="number"
                                    />

                                    <Select
                                        label="Invited By"
                                        value={form.invited_by}
                                        error={getFieldError('invited_by')}
                                        onChange={(v) => handleInput('invited_by', v)}
                                        isAsync
                                        searchCallback={(data) => AdminUsersApi.get(null, data)}
                                        searchLabelKey={(record) => record.full_name ?? record.email ?? record.store_number}
                                        allowNull={true}
                                    />
                                </>
                            }

                            <div>
                                <Toggle
                                    label="Enabled"
                                    labelPlacement="top"
                                    value={form.enabled}
                                    id="enabled"
                                    value={form.enabled}
                                    error={getFieldError('enabled')}
                                    onChange={(v) => handleInput('enabled', v)}
                                />
                            </div>
                        </div>

                        {window.base.features.subscriptions && !user_id &&
                            <div className="mb-4">
                                <CashierSubscriptionSelector
                                    form={form}
                                    handleInput={handleInput}
                                    getFieldError={getFieldError}
                                    admin={true}
                                    collectPaymentMethod={true}
                                    group_ids={form.group_ids}
                                />
                            </div>
                        }
                    </div>

                    <div className="px-6 pt-6 flex justify-end gap-4">
                        <Link to="/admin/users">
                            <SecondaryButton type="button" text="Back" />
                        </Link>

                        <PrimaryButton
                            text="Save"
                            working={working}
                        />
                    </div>
                </form>
            </AdminLayout>
        )
    }
}

export default FormHandler(UsersStore);
